export const storageKeys = {
    abtests: {
        unleashGroups: 'unleashGroups',
        testSegment: 'testSegment',
        testSegment0: 'testSegment0',
        testSegment1: 'testSegment1',
        testSegment2: 'testSegment2',
        testSegment3: 'testSegment3',
        testSegment4: 'testSegment4',
        testSegment5: 'testSegment5',
        testSegment6: 'testSegment6',
        testSegment7: 'testSegment7',
        testSegment8: 'testSegment8',
        testSegment9: 'testSegment9',
        testSegment10: 'testSegment10',
        testSegment11: 'testSegment11',
        testSegment12: 'testSegment12',
        testSegment13: 'testSegment13',
        testSegment14: 'testSegment14'
    },
    auth: {
        accessToken: 'access_token',
        authBridgeHandOffPageLoad: 'auth_bridge_hand_off_page_load',
        isLoggedIn: 'isLoggedIn',
        pendingAuthBridgeRequest: 'pending_auth_bridge_request'
    },
    cart: {
        cartToken: 'cart_token',
        referralPromoMaterial: 'referral_promo_material'
    },
    email: {
        freeMaterialDownloadUserEmail: 'freeMaterialDownloadUserEmail',
        emailRatingRedirect: 'email_rating_redirect',
        emailHash: 'emailHash',
        emailSHA256Hash: 'emailSHA256Hash'
    },
    favorites: {
        skipCatalogWishlistFolderModal: 'skipCatalogWishlistFolderModal',
        foldersAnnouncementShown: 'foldersAnnouncementShown'
    },
    general: {
        lastVisitedWorld: 'lastVisitedWorld',
        maintenanceWorkBanner: 'maintenanceWorkBanner',
        redirectLink: 'redirect_link',
        clientId: 'client_id',
        GAClientId: '_ga',
        GATrackId: '_gid',
        appBanner: 'appBanner',
        lastError: 'lastError',
        wasOnceRedirectedToProfileAfterLogin: 'wasOnceRedirectedToProfileAfterLogin',
        phraseEditor: 'phraseEditor',
        trackSid: 'track_sid',
        uiTest: 'uiTest',
        postponedQE: 'postponedQE',
        countryCode: 'countryCode',
        hideSchoolPopUp: 'hideSchoolPopUp',
        referralCode: 'referralCode',
        failedQualityEvents: 'failedQualityEvents',
        promoActivationRedirectShown: 'promoActivationRedirectShown',
        voucherRulesAnnouncementShown: 'voucherRulesAnnouncementShown',
        checkoutSource: 'checkout_source',
        adaptAiToolBannerClosed: 'adapt_ai_tool_banner_closed',
        // AB TEST - AI-1771
        adaptLaunchBannerClosed: 'adapt_launch_banner_closed'
    },
    interactive: {
        interactiveAnnouncementShown: 'interactiveAnnouncementShown',
        interactiveSearchOption: 'interactive-search-option'
    },
    material: {
        viewedMaterials: 'viewed_materials'
    },
    myUploads: {
        aiLabellingPopupDismissed: 'aiLabellingPopupDismissed',
        materialToBeEdit: 'toBeEdited',
        authorsCabinetLastSortOption: 'authorsCabinetLastSortOption'
    },
    payments: {
        lastPaymentMethod: 'lastPaymentMethod',
        isBuyNowFlow: 'isBuyNowFlow',
        lastOrderTracked: 'lastOrderTracked'
    },
    prices: {
        interactionWithPricePolicyModal: 'interactionWithPricePolicyModal',
        currencyCode: 'currencyCode'
    },
    qualityReport: {
        welcomeModalShown: 'qualityReportWelcomeModalShown',
        iconOnboardingModalShown: 'qualityIconOnboardingModalShown'
    },
    search: {
        searchViewType: 'SRView',
        showAcquired: 'show-acquired',
        prevSearchQueries: 'prevSearchQueries'
    },
    user: {
        userId: 'userId',
        impersonated: 'impersonated',
        userSD: 'userSD',
        consentBannerInteraction: 'uc_user_interaction',
        isSeller: 'isSeller',
        oauthUserId: 'oauth_user_id',
        userSlug: 'userSlug',
        creationSource: 'creationSource',
        searchType: 'searchType',
        registeredFromSellerPage: 'registeredFromSellerPage',
        statsig: 'statsigUser'
    },
    metrics: {
        analyticsWelcomeModalShown: 'analyticsWelcomeModalShown'
    },
    ai: {
        customiserBarDismissCount: 'customiser_bar_dismiss_count',
        customiserBarOptedIn: 'customiser_bar_opted_in',
        aiToolsAdaptModalDismissed: 'ai_tools_adapt_modal_dismissed',
        // AB TEST - AI-1771
        adaptLaunchModalDismissed: 'adapt_launch_modal_dismissed'
    }
};
